import { useCreateAndUploadEmeraMediaForMetaMutation } from '@/editor/services/http/media-library.api';
import { EDITOR_LS_CONSTANTS } from '@/editor/shared/constants/editor-LS.constants';
import { IMediaLibraryImageModel } from '@/shared/models/media-library/media-library-image.model';
import { getValueFromLs } from '@/shared/services/localstorage';
import { useAppSelector } from '@/store/hooks/redux';
import { useCallback } from 'react';
import { AvailablePlatformsEnum } from '@/editor/shared/constants/available-platforms';

const useManagement = () => {
  const activePlatforms = JSON.parse(getValueFromLs(EDITOR_LS_CONSTANTS.ACTIVE_SOCIAL_MEDIA_PLATFORMS) as string);
  const selectedCreativeType = useAppSelector((state) => state.creativeStepSliceReducer.selectedCreativeType);
  const creativeFormsState = useAppSelector((state) => state.creativeStepSliceReducer.creativeFormsState);
  const data = creativeFormsState[AvailablePlatformsEnum.META][selectedCreativeType];
  const [createMediaFromPropertyId, { isLoading, isError, isSuccess }] = useCreateAndUploadEmeraMediaForMetaMutation();

  const getData = useCallback(
    async (images: IMediaLibraryImageModel[]) => {
      try {
        const res = await createMediaFromPropertyId({
          propertyFileId: images[0].id,
          payload: {
            withSave: true,
            isMobile: false,
            localAreaName: data?.localAreaName!,
            propertyInfo: data?.propertyInfo!,
            desc: data?.description!,
            brokerName: data?.employeeName!,
            brokerTitle: data?.employeeTitle!,
          },
        });

        return { ...res, activePlatforms };
      } catch (error) {
        console.error('Error creating image:', error);
        throw error;
      }
    },
    [createMediaFromPropertyId, activePlatforms, selectedCreativeType]
  );

  return { getData, loadingMetaForEmera: isLoading };
};

export default useManagement;
